import React from 'react';
import { Snackbar } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme, withStyles } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ClearAllIcon from '@material-ui/icons/ClearAll';

const customTheme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiSnackbar: {
      root: {
        minWidth: '600px !important',
      },
    },
    MuiSnackbarContent: {
      root: {
        minWidth: '600px !important',
        padding: '8px 16px !important',
      },
    },
  },
});

const StyledBadge = withStyles(() => ({
  badge: {
    backgroundColor: '#ff5731',
    color: 'white',
    width: '22px',
    height: '22px',
    fontSize: '14px',
    fontWeight: 300,
    top: '-1px',
    borderRight: '1px solid #808080',
    position: 'relative',
    transform: 'none',
  },
}))(Badge);

export default function DockerPanel({ children, count, onCancel, onSelectAll }) {
  const [state, setState] = React.useState({
    open: true,
    vertical: 'bottom',
    horizontal: 'center',
  });
  const { vertical, horizontal, open } = state;
  const handleClose = () => {
    setState({ ...state, open: false });
    onCancel();
  };

  return (
    <ThemeProvider theme={customTheme}>
      <Snackbar
        message={
          <React.Fragment>
            <StyledBadge badgeContent={count || 0} color="primary" />{' '}
            <span style={{ margin: '0 4px', color: '#808080' }}>Selected</span>
            <IconButton
              size="small"
              className="docker-action-btn"
              aria-label="close"
              color="inherit"
              onClick={onSelectAll}
            >
              <ClearAllIcon />
              <span style={{ fontSize: '14px', marginLeft: '5px' }}>Select All</span>
            </IconButton>
          </React.Fragment>
        }
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        key={vertical + horizontal}
        action={
          <React.Fragment>
            {children}
            <div style={{ borderLeft: '1px solid rgba(255,255,255, .3)', marginLeft: '10px' }}>
              <IconButton aria-label="close" color="inherit" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </div>
          </React.Fragment>
        }
      />
    </ThemeProvider>
  );
}
